module.exports = __webpack_public_path__ + "static/nat-5-523dfedb36fd1b030765393e96e2a4b5.jpg";